import * as React from "react";
import { useHistory } from "react-router-dom";

import { byPrefixAndName } from "@awesome.me/kit-d560caf08c/icons/modules";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { searchResults } from "../config/router";

interface SearchProps {
  onToggle: () => void;
  showInput: boolean;
}

export const Search = ({ onToggle, showInput }: SearchProps) => {
  const history = useHistory();
  const [searchValue, setSearchValue] = React.useState("");

  const inputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchValue(event.target.value);
  };

  const searchClick = () => {
    if (showInput && searchValue) {
      const url = searchResults(searchValue);
      history.push(url);

      return;
    }
    onToggle();
  };

  const enterCatcher = (event: React.KeyboardEvent) => {
    if (event.key === "Enter" && searchValue) {
      const url = searchResults(searchValue);
      history.push(url);
    }
  };

  return (
    <>
      {showInput && (
        <li className="navigation-item navigation-input mt-2">
          <input
            data-testid="search-input"
            type="text"
            placeholder="Rapu"
            onChange={inputChange}
            onKeyDown={enterCatcher}
            // eslint-disable-next-line jsx-a11y/no-autofocus
            autoFocus
          />
        </li>
      )}
      <li className="navigation-item navigation-link button primary mx-0">
        <FontAwesomeIcon
          data-testid="search-icon"
          icon={byPrefixAndName.fas["magnifying-glass"]}
          onClick={searchClick}
        />
      </li>
    </>
  );
};
